export default "__VITE_ASSET__BHE4wyNO__"